import styles from "./ButtonWithCopyIcon.module.scss";
import { useEffect, useState } from "react";
import { ReactComponent as CopyIcon } from "../../assets/icons/copy.svg";
import { ReactComponent as TickIcon } from "../../assets/icons/tick.svg";
import { ReactComponent as X } from "../../assets/icons/errorX.svg";
import { Tooltip } from "../Tooltip/Tooltip";

export const ButtonWithCopyIcon = ({
  buttonText = "Copy",
  clickHandler = () => {},
  copied = false,
  setCopied,
  error = false,
  setError,
}) => {
  const [hoverState, setHoverState] = useState(false);

  useEffect(() => {
    if (copied || error) {
      setTimeout(() => {
        setCopied(false);
        setError(false);
      }, 3000);
    }
  }, [copied, error]);

  return (
    <div
      onClick={clickHandler}
      onMouseOver={() => setHoverState(true)}
      onMouseLeave={() => setHoverState(false)}
      className={styles.buttonWithCopyIconContainer}
    >
      {hoverState && <Tooltip text="Copy" />}
      {copied ? (
        <TickIcon className={styles.tickIcon} style={{ color: "green" }} />
      ) : error ? (
        <X className={styles.errorIcon} />
      ) : (
        <CopyIcon className={styles.copyIcon} />
      )}
      <button>{copied ? "Copied" : buttonText}</button>
    </div>
  );
};
